/* FrontrowMD, loaded when it's needed rather than when the page is.
 *
 * Each widget is a frame that boots their whole app, and their script adds
 * more frames of its own. Nine of them at page load is what made the product
 * page feel slow. So: frames get their src, and scripts get inserted, only
 * when the widget scrolls within reach — and Clinician AI only on the first
 * tap of an "Ask" button.
 */
(function () {
  'use strict';
  if (window.ttFrontrow) return;

  var pending = {};

  function loadScript(src) {
    if (!src) return Promise.resolve();
    if (pending[src]) return pending[src];
    pending[src] = new Promise(function (resolve) {
      var s = document.createElement('script');
      s.async = true;
      s.src = src;
      s.onload = resolve;
      s.onerror = resolve; // a failed third party must never wedge our page
      document.head.appendChild(s);
    });
    return pending[src];
  }

  function activate(el) {
    if (el.dataset.ttFrontrowOn) return Promise.resolve();
    el.dataset.ttFrontrowOn = '1';
    el.querySelectorAll('iframe[data-src]').forEach(function (f) {
      f.src = f.dataset.src;
    });
    return loadScript(el.dataset.script);
  }

  var io =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          function (entries) {
            entries.forEach(function (e) {
              if (!e.isIntersecting) return;
              activate(e.target);
              io.unobserve(e.target);
            });
          },
          { rootMargin: '900px 0px' }
        )
      : null;

  function scan() {
    document.querySelectorAll('[data-tt-frontrow]').forEach(function (el) {
      if (el.dataset.ttFrontrowOn || el.dataset.lazy === 'click') return;
      if (io) io.observe(el);
      else activate(el);
    });
  }

  window.ttFrontrow = {
    // used by the Ask buttons: load Clinician AI on demand and resolve when its script ran
    load: function (type) {
      var el = document.querySelector('[data-tt-frontrow="' + type + '"]');
      return el ? activate(el) : Promise.resolve();
    },
    scan: scan,
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  document.addEventListener('shopify:section:load', scan);
})();
